'use client';
/**
 * Генерирует набор цветовых вариаций на основе переданного базового цвета, включая различные уровни прозрачности.
 *
 * @param {string} baseColor - Базовый цвет в формате RGB
 * @returns {Record<number, string>} Объект, в котором ключи - это уровни прозрачности (от 0 до 100), а значения - соответствующие цветовые значения в формате RGBA.
 *
 * @example
 *
 * const variants = generateColorInvariants('255, 255, 255');
 * console.log(variants[50]); // Выведет 'rgba(255, 255, 255, 0.50)'
 *
 */ const generateColorInvariants = (baseColor)=>{
    const opacities = [
        100,
        90,
        80,
        70,
        60,
        50,
        40,
        30,
        20,
        15,
        10,
        5,
        0
    ];
    return opacities.reduce((variant, opacity)=>{
        const alpha = opacity / 100;
        variant[opacity] = `rgba(${baseColor}, ${alpha.toFixed(2)})`;
        return variant;
    }, {});
};

export { generateColorInvariants };
//# sourceMappingURL=generateColorInvariants.js.map
